module.exports = __webpack_public_path__ + "img/header-dark.640ab328.svg";